/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-19 13:50:09
 * @LastEditTime: 2025-02-20 18:03:49
 */
import Http from '@/plugins/axiosHttp';

export function getKyberSMKey() {
  return Http.get('api/taskApi/cryptogram.json');
}

// 后端生成key
export function generateKey(params:any) {
  return Http.jsonPost('api/taskApi/generateKey.json', params);
}

//用户中心获取公钥
// export function getKyberSMKeyCore() {
//   return Http.get('uc/core/user/getPublicKey.json');
// }

export function getKyberSMKeyCore() {
  return Http.get('uc/core/user/cryptogram.json');
}


// 用户中心后端生成key
export function generateKeyCore(params:any) {
  return Http.jsonPost('uc/core/user/generateKey.json', params);
}

// 用户信息解密
export function encryUserInfo(data:any) {
  return Http.jsonPost('uc/userInfo/userInfo.json',data);
}
// 退出登录
export function logout() {
  return Http.jsonPost('uc/core/user/logout.json', {});
}